import React from 'react';
import {validateForm} from "../../../../util/validation";
import Form from "../../form";
import TextInput from "../../../atoms/text-input";
import InputStack from "../../input-stack";
import TagInput from "../../../atoms/tag-input";
import Label from "../../../atoms/label";

class PrintNameplate extends React.Component {
    static defaultProps = {
        onCancel: () => {
        },
        onSave: () => {
        }
    };
    
    constructor(props) {
        super(props);
        
        this.state = {
            printing: false,
        };
        
        this.form = React.createRef();
    }
    
    validateForm(form, data) {
        validateForm(form, data, {
            title: ['required', 'string'],
            genres: ['required', 'array'],
            subgenres: ['array'],
        });
    }
    
    onSubmit(data) {
        const title = data.title;
        const genres = data.genres;
        const subgenres = data.subgenres;
        
        console.log(data)
        
        this.setState({ printing: true });
        
        // Helper function to extract and clean values from tag arrays
        const extractTagValues = (tagData) => {
            if (!tagData) return '';
            
            let values = [];
            
            if (Array.isArray(tagData)) {
                // Handle array of objects or strings
                values = tagData.map(item => {
                    if (typeof item === 'string') {
                        return item;
                    } else if (typeof item === 'object' && item !== null) {
                        return item.value || item.label || item.text || String(item);
                    }
                    return String(item);
                });
            } else if (typeof tagData === 'string') {
                try {
                    // Try to parse JSON string like ["value1", "value2"]
                    const parsed = JSON.parse(tagData);
                    if (Array.isArray(parsed)) {
                        values = parsed.map(item => String(item));
                    } else {
                        // Single string value
                        values = [String(parsed)];
                    }
                } catch (e) {
                    // Not JSON, treat as comma-separated string or single value
                    if (tagData.includes(',')) {
                        values = tagData.split(',').map(item => item.trim());
                    } else {
                        values = [tagData];
                    }
                }
            } else {
                // Handle other data types
                values = [String(tagData)];
            }
            
            // Filter out empty values and join with commas
            return values.filter(v => v && v.length > 0).join(',');
        };
        
        const genresString = extractTagValues(genres);
        const subgenresString = extractTagValues(subgenres);
        
        console.log('Original genres:', genres);
        console.log('Original subgenres:', subgenres);
        console.log('Processed genres:', genresString);
        console.log('Processed subgenres:', subgenresString);
        
        // Build URL manually to preserve commas and spaces
        let queryParams = [`title=${encodeURIComponent(title)}`];
        
        if (genresString) {
            queryParams.push(`genres=${encodeURIComponent(genresString)}`);
        }
        
        if (subgenresString) {
            queryParams.push(`subgenres=${encodeURIComponent(subgenresString)}`);
        }
        
        const printUrl = process.env.REACT_APP_WEB_HOST + `/print/nameplate/?${queryParams.join('&')}`;
        console.log('Opening URL:', printUrl);
        window.open(printUrl, '_blank');
        
        setTimeout(() => {
            this.setState({ printing: false });
        }, 3000);
    }
    
    render() {
        return (
            <React.Fragment>
                {this.state.printing && (
                    <Label title="Printing..."/>
                )}
                
                <Form
                    validate={(form, data) => this.validateForm(form, data)}
                    onSubmit={(data) => this.onSubmit(data)}
                    submitButtonText={'Print'}
                    submitButtonDisabled={this.state.printing}
                    ref={this.form}
                >
                    <InputStack modifiers={'alternate-direction'}>
                        <TextInput
                            name="title"
                            label="Title"
                            showRequiredIndicator={true}
                            focus={true}
                            disabled={this.state.printing}
                        />
                        <TagInput
                            name="genres"
                            label="Genres"
                            allowCustomTags={true}
                            showRequiredIndicator={true}
                            disabled={this.state.printing}
                        />
                        <TagInput
                            name="subgenres"
                            label="Subgenres"
                            allowCustomTags={true}
                            disabled={this.state.printing}
                        />
                    </InputStack>
                </Form>
            </React.Fragment>
        );
    }
}

export default PrintNameplate;
